module.exports = __webpack_public_path__ + "static/use_bold_text-b8ffbb7fa0cfc01f9b9bf4ce62dd4f17.png";